import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { selectAction, setMasterFormAction, setServiceFormAction } from "../../redux/rootReducer";
import { SELECT_INITIAL, SERVICE_FORM_INITIAL } from "../../redux/initialStateConstant";
import { UpdateServiceThunk } from "../../redux/thunks/UpdateServiceThunk";
import Select from "../Select/Select";

const ServiceForm = () => {
    const dispatch = useDispatch();
    const services_settings = useSelector(state => state.services_settings);
    const service_form = useSelector(state => state.service_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <div className="form__close"
                            onClick={ () => {
                                dispatch(setServiceFormAction(SERVICE_FORM_INITIAL));
                            } }
                        />
                        <div className="form__title">Услуга</div>
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Название услуги</div>
                        <input type="text" className="input"
                            value={ service_form.name }
                            onInput={ event => {
                                dispatch(setServiceFormAction({
                                    ...service_form,
                                    name: event.target.value
                                }));
                            } }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Специализация</div>
                        <Select
                            current={ service_form.specialization.name }
                            type={ 'service_specialization' }
                            options={ services_settings.specializations }
                            handler={ (elem) => {
                                dispatch(setServiceFormAction({
                                    ...service_form,
                                    specialization: elem
                                }));
                                dispatch(selectAction(SELECT_INITIAL));
                            } }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Стоимость</div>
                        <input type="number" className="input"
                               value={ service_form.price }
                               onInput={ event => {
                                   dispatch(setServiceFormAction({
                                       ...service_form,
                                       price: event.target.value
                                   }));
                               } }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Общая длительность (мин.)</div>
                        <input type="number" className="input"
                               value={ service_form.duration }
                               onInput={ event => {
                                   dispatch(setServiceFormAction({
                                       ...service_form,
                                       duration: event.target.value
                                   }));
                               } }
                        />
                    </div>
                    <div className="form__field">
                        <div className="input__caption input__caption--required">Длительность услуги (мин.)</div>
                        <input type="number" className="input"
                               value={ service_form.net_duration }
                               onInput={ event => {
                                   dispatch(setServiceFormAction({
                                       ...service_form,
                                       net_duration: event.target.value
                                   }));
                               } }
                        />
                    </div>
                    <div className="form__field">
                        <div className="button button--green"
                            onClick={ () => {
                                dispatch(UpdateServiceThunk({
                                    service_id: service_form.id,
                                    name: service_form.name,
                                    specialization_id: service_form.specialization.id,
                                    price: service_form.price,
                                    duration: service_form.duration,
                                    net_duration: service_form.net_duration
                                }));
                            } }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ServiceForm;